module.exports = __webpack_public_path__ + "img/number-3.5baf99a2.png";